// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"6dfc90a8","521":"4cacc1fa"}[chunkId] + ".chunk.js";
};